/* ---------------------------------------------------------------------------
   1 Oct 2026 (V.046): Un-Stitch on a sized suit no longer asks for Height and
   the order says Unstitched.
   1 Oct 2026 (V.045): the closest ready size row asks a question, drops
   Un-Stitch, and the top size chips fade while Custom or Plus is chosen.
   1 Oct 2026: the price at the top now follows the size chip (see
   pickVariant). Before that a dearer size kept showing the base price.
   Sarvati size selector, version 13. 28 September 2026 (Chirag and Swati's
   review): no padding, closure or design in the size flow; a price under
   every size chip; Fall and Edging back as an add on; Petticoat/Shapewear
   with a material dropdown; Pre-Drape wording; the custom note links the
   measurement form from the stitching product; Size chart; darker prices;
   the "Stitching Service" heading hidden. Design, padding and closure code
   is kept for the design sheet but no longer shown or required.
   Version 12. 21 September 2026.
   v11 made money parsing currency agnostic. v12 adds:
   - VARIANT MODE for suits ("Sarvati Suits" carry real S to 2XL variants
     and the size is stitched into the price): the size chips pick the
     theme's own variant and the theme's size picker is hidden. No
     Unstitched/Stitched step, no padding, closure or design. "Custom
     stitching" adds the Salwar Kameez Stitching product.
   - Lehenga: hip in the size line and the guide, and a compulsory Height
     drop down (4'6" to 6'6") so the lehenga length can be cut right.
   - An embroidery note under the blouse design picker.

   STEP 1  Blouse stitching option:  [Unstitched] [Stitched]
           Unstitched shows only the add ons: fall and edging, petticoat,
           ready to wear.
   STEP 2  Stitched shows the size row: XS S M L XL 2XL · Custom stitching.
           A standard size shows, all COMPULSORY with "Please select":
             Padding · Closure · Blouse design
           then petticoat and ready to wear. Fall and edging is included in
           a standard size. Custom stitching shows ready to wear, fall and
           edging, petticoat, and no design or padding.

   HOW IT TALKS TO THE THEME (changed in v10). The theme's own add-on
   script decides what goes in the cart by reading which of ITS buttons
   carry the class "is-selected" at the moment of submit. Earlier versions
   set that by simulating a click on those hidden buttons; iOS Safari
   delivered those clicks late or not at all, which is what Chirag filmed
   as switches "facing issues". Now the class is set directly, no clicks,
   and each add on row is one big tap target with a short guard against
   double fires.

   FALL: with fallMode "price" (Blouse Stitching priced with fall inside)
   no fall product is added for a size; the order still says "Fall &
   edging: Included". With "product" the fall product is added and the
   cart merge folds it into the stitching row.

   THE PRICE. The product's own price at the top of the page becomes the
   total of garment plus everything chosen, and goes back when nothing is.
   The size line shows bust and waist; 2XL adds "for sizes above 2XL choose
   Custom stitching".
   --------------------------------------------------------------------------- */
(function () {
  var CFG = window.SarvatiSizeConfig;
  if (!CFG || !CFG.on || window.SarvatiSizeReady) return;
  window.SarvatiSizeReady = true;

  var LEHENGA = /lehenga/i.test(CFG.vendor || '') || /lehenga/i.test(CFG.type || '');
  var SUIT = /suit/i.test(CFG.garment || '');
  var GARMENT = SUIT ? 'Suit' : (/lehenga/i.test(CFG.garment || '') ? 'Lehenga' : (LEHENGA ? 'Choli' : 'Blouse'));
  var VSIZES = (CFG.variantSizes || []).filter(function (x) { return x && x.v; });
  var VMODE = VSIZES.length > 0;
  var HEIGHTS = (function () { var out = []; for (var ft = 4; ft <= 6; ft++) for (var i = 0; i < 12; i++) { if (ft === 4 && i < 6) continue; if (ft === 6 && i > 6) break; out.push(ft + "'" + i + '"'); } return out; })();
  var T = CFG.text || {};
  var WA = CFG.whatsapp || '';
  var FALL_MODE = CFG.fallMode === 'price' ? 'price' : 'product';
  var CLOSURES = CFG.closures || ['Back open', 'Front open', 'Side zip'];
  var PADDINGS = CFG.paddings || ['Padded', 'Not padded'];
  var CUSTOM = T.custom || 'Custom stitching';
  var PLUS = T.plus || 'Plus size stitching';
  var PLEASE = T.pleaseSelect || 'Please select';
  var DESIGNS = (CFG.designs || []).slice().sort(function (a, b) {
    return String(a.code || a.name).localeCompare(String(b.code || b.name), undefined, { numeric: true });
  });

  var SIZES = [['XS', 34, 30, 36], ['S', 36, 32, 38], ['M', 38, 34, 40], ['L', 40, 36, 42], ['XL', 42, 38, 44], ['2XL', 44, 40, 46]];

  var CSS =
    '.svsz{margin:16px 0 6px}' +
    '.svsz__lab{display:flex;align-items:baseline;justify-content:space-between;gap:10px;margin:0 0 8px;' +
      'font-size:12px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#1a1a1a}' +
    '.svsz__lab button{appearance:none;background:none;border:0;padding:0;cursor:pointer;font:inherit;' +
      'font-size:12.5px;font-weight:700;letter-spacing:0;text-transform:none;color:#9a5b0a;text-decoration:underline;' +
      'text-underline-offset:2px}' +
    '.svsz__row{display:flex;flex-wrap:wrap;gap:8px}' +
    '.svsz__c{appearance:none;-webkit-appearance:none;cursor:pointer;min-width:46px;min-height:42px;padding:0 13px;' +
      'border:1px solid #cfc6bb;border-radius:3px;background:#fff;color:#1a1a1a;font:inherit;font-size:13px;' +
      'font-weight:600;line-height:1.2;letter-spacing:.02em;text-align:center;touch-action:manipulation;' +
      '-webkit-tap-highlight-color:transparent;transition:background .15s,border-color .15s}' +
    '.svsz__c--pill{border-radius:22px;padding:0 18px;min-height:44px}' +
    '.svsz__c b{display:block;font-size:11px;font-weight:600;line-height:1.1;margin-top:3px;color:#3d3632;letter-spacing:0}' +
    '.svsz__c.is-on b{color:#e9dcc3}' +
    '.svsz__c--priced{min-height:50px;padding:6px 12px}' +
    '.svsz__c--size{flex:1 1 0;min-width:40px;padding:0 4px}' +
    '.svsz__c--custom{flex:0 0 100%;display:flex;align-items:center;justify-content:space-between;gap:10px;padding:0 12px;min-height:42px;margin-top:2px;text-align:left}' +
    '.svsz__c--custom small{font-weight:400;font-size:11.5px;color:#6e645c;margin-left:6px}' +
    '.svsz__c--custom.is-on small{color:#d9cdb8}' +
    '.svsz__c--custom b{display:inline;margin:0;font-size:13px;font-weight:700;color:#1a1a1a}' +
    '.svsz__c--custom.is-on b{color:#fff}' +
    '.svsz__lab em{font-style:normal;font-weight:500;letter-spacing:0;text-transform:none;color:#3d3632;margin-left:6px}' +
    '.svsz__mat{margin:0 0 4px;padding:6px 0 10px;border-top:1px dashed #ebe5dc}' +
    '.svsz__mat[hidden]{display:none}' +
    '.svsz__c.is-on{background:#1a1a1a;border-color:#1a1a1a;color:#fff}' +
    '.svsz__row--faded .svsz__c:not(.svsz__c--custom){opacity:.4}' +
    '.svsz__row--faded .svsz__c:not(.svsz__c--custom):hover{opacity:.75}' +
    '.svsz__basehint{margin:0 0 8px;font-size:12px;line-height:1.45;color:#3d3632}' +
    '.svsz__c[disabled]{opacity:.35;cursor:not-allowed;text-decoration:line-through}' +
    '.svsz__one{margin-top:8px}' +
    '.svsz__hint{margin:8px 0 0;font-size:12px;line-height:1.45;color:#3d3632}' +
    '.svsz__step{display:none;margin-top:16px}' +
    '.svsz__step.is-on{display:block}' +
    '.svsz__note{margin:10px 0 0;min-height:20px;font-size:12.5px;line-height:1.5;color:#1a1a1a;letter-spacing:.02em}' +
    '.svsz__note small{display:block;font-size:11.5px;color:#5b514a;margin-top:2px}' +
    '.svsz__note:empty{display:none}' +
    '.svsz__note b{font-weight:600;color:#1a1a1a}' +
    '.svsz__note i{font-style:normal;color:#8a7f76;padding:0 4px}' +
    '.svsz__note a{color:#9a5b0a;font-weight:600;text-decoration:underline;text-underline-offset:2px}' +
    '.svsz__note small{display:block;font-size:11.5px;color:#6e645c;margin-top:2px}' +
    '.svsz__stylist{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin-top:8px;font-size:12px;color:#1a1a1a}' +
    '.svsz__stylist a{display:inline-flex;align-items:center;gap:5px;padding:4px 10px;border:1px solid #25D366;border-radius:14px;' +
      'color:#0b6b37;background:#f0fbf4;font-size:11px;font-weight:700;text-decoration:none;letter-spacing:.02em;white-space:nowrap}' +
    '.svsz__stylist a svg{width:12px;height:12px;fill:#25D366}' +
    '.svsz__two{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:8px}' +
    '.svsz__sel{position:relative;display:block}' +
    '.svsz__sel small{display:block;font-size:10.5px;letter-spacing:.08em;text-transform:uppercase;color:#6e645c;margin:0 0 4px;font-weight:600}' +
    '.svsz__sel small::after,.svsz__pickwrap small::after{content:" *";color:#b3261e}' +
    '.svsz__sel select{appearance:none;-webkit-appearance:none;width:100%;font:inherit;font-size:13.5px;color:#1a1a1a;' +
      'background:#fff;border:1px solid #cfc6bb;border-radius:3px;padding:11px 34px 11px 10px;line-height:1.2;cursor:pointer}' +
    '.svsz__sel select.is-empty{color:#8a7f76}' +
    '.svsz__sel::after,.svsz__pick::after{content:"";position:absolute;right:16px;width:7px;height:7px;' +
      'border-right:1px solid #6e645c;border-bottom:1px solid #6e645c;transform:rotate(45deg);pointer-events:none}' +
    '.svsz__sel::after{bottom:16px}' +
    '.svsz__pickwrap{margin-top:10px}' +
    '.svsz__pickwrap small{display:block;font-size:10.5px;letter-spacing:.08em;text-transform:uppercase;color:#6e645c;margin:0 0 4px;font-weight:600}' +
    '.svsz__pick{position:relative;display:flex;align-items:center;gap:12px;width:100%;cursor:pointer;min-height:46px;' +
      'font:inherit;font-size:13.5px;text-align:left;color:#1a1a1a;background:#fff;touch-action:manipulation;' +
      'border:1px solid #cfc6bb;border-radius:3px;padding:8px 40px 8px 10px}' +
    '.svsz__pick::after{top:50%;margin-top:-5px}' +
    '.svsz__pick img{width:58px;height:44px;object-fit:cover;object-position:25% 30%;border-radius:2px;flex:0 0 auto;background:#f3ede4}' +
    '.svsz__pick img[hidden]{display:none}' +
    '.svsz__pick.is-empty span{color:#8a7f76}' +
    '.svsz__pick i{font-style:normal;display:block;font-size:11px;color:#6e645c;margin-top:2px}' +
    '.svsz__pick--static{cursor:default}.svsz__pick--static::after{display:none}' +
    '.is-missing select,.svsz__pick.is-missing{border-color:#b3261e;box-shadow:0 0 0 1px #b3261e}' +
    '.svsz__err{display:none;margin:10px 0 0;padding:9px 11px;border-left:2px solid #b3261e;background:#fdecea;color:#8a1c14;font-size:12.5px;line-height:1.45}' +
    '.svsz__err.is-on{display:block}' +
    '.svsz__adds{margin-top:16px}' +
    '.svsz__add{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:11px 0;' +
      'border-top:1px solid #ebe5dc;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent;user-select:none}' +
    '.svsz__add:last-child{border-bottom:1px solid #ebe5dc}' +
    '.svsz__add[hidden]{display:none}' +
    '.svsz__add span{font-size:13.5px;color:#1a1a1a;line-height:1.3}' +
    '.svsz__add span i{font-style:normal;color:#1a1a1a;font-weight:600;font-size:12.5px;margin-left:6px;white-space:nowrap}' +
    '.svsz__add span a{color:#a77c33;font-size:12px;margin-left:6px;text-decoration:underline;cursor:pointer}' +
    '.svsz__sw{flex:0 0 auto;width:40px;height:23px;border-radius:12px;background:#d9d2c7;position:relative;' +
      'transition:background .15s;pointer-events:none}' +
    '.svsz__sw::after{content:"";position:absolute;top:3px;left:3px;width:17px;height:17px;border-radius:50%;' +
      'background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:left .15s}' +
    '.svsz__sw.is-on{background:#C79A4B}' +
    '.svsz__sw.is-on::after{left:20px}' +
    '.svsz__c:focus-visible,.svsz__add:focus-visible,.svsz__pick:focus-visible,.svsz__sel select:focus-visible,.svsz__lab button:focus-visible{outline:2px solid #C79A4B;outline-offset:2px}' +
    '.svsz-sheet{position:fixed;inset:0;z-index:10050;display:flex;align-items:flex-end;justify-content:center;' +
      'background:rgba(20,16,14,.5)}' +
    '.svsz-sheet__card{background:#fff;width:100%;max-width:560px;max-height:88vh;overflow:auto;' +
      'border-radius:8px 8px 0 0;padding:18px 18px 26px;color:#1a1a1a}' +
    '.svsz-sheet__top{display:flex;align-items:center;justify-content:space-between;margin-bottom:12px}' +
    '.svsz-sheet__top h3{margin:0;font-size:18px;font-weight:500;text-transform:none;letter-spacing:0}' +
    '.svsz-sheet__x{appearance:none;background:none;border:0;font-size:24px;line-height:1;padding:4px 8px;cursor:pointer;color:#6e645c}' +
    '.svsz-sheet table{width:100%;border-collapse:collapse;font-size:13px;font-variant-numeric:tabular-nums}' +
    '.svsz-sheet th,.svsz-sheet td{padding:8px 6px;border-bottom:1px solid #ebe5dc;text-align:center}' +
    '.svsz-sheet th{font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#6e645c;font-weight:600}' +
    '.svsz-sheet td:first-child{font-weight:600;text-align:center}' +
    '.svsz-sheet p{font-size:12.5px;line-height:1.5;color:#3d3632;margin:12px 0 0}' +
    '.svsz-sheet__grid{display:grid;grid-template-columns:repeat(2,1fr);gap:10px}' +
    '.svsz-sheet__chart{font-size:13px;line-height:1.5;color:#3d3632}.svsz-sheet__chart img{max-width:100%;height:auto}' +
    '.svsz-sheet__chart table{margin:8px 0}.svsz-sheet__chart h1,.svsz-sheet__chart h2,.svsz-sheet__chart h3{font-size:16px;margin:10px 0 6px}' +
    '.svsz-d{appearance:none;cursor:pointer;padding:0;background:#fff;text-align:left;color:inherit;' +
      'border:1px solid #e3dccf;border-radius:3px;display:block;touch-action:manipulation}' +
    '.svsz-d img{width:100%;aspect-ratio:4/3;object-fit:cover;display:block;border-radius:2px 2px 0 0;background:#f3ede4}' +
    '.svsz-d img,.svsz__pick img{pointer-events:none;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;-webkit-user-drag:none}' +
    '.svsz-d span{display:block;padding:7px 8px 8px;font-size:12px;line-height:1.35;color:#3d3632}' +
    '.svsz-d span i{font-style:normal;color:#8a7f76;font-size:11px}' +
    '.svsz-d.is-on{border-color:#C79A4B;box-shadow:inset 0 0 0 1px #C79A4B}' +
    '@media (min-width:600px){.svsz-sheet{align-items:center;padding:20px}.svsz-sheet__card{border-radius:8px}' +
      '.svsz-sheet__grid{grid-template-columns:repeat(3,1fr)}}' +
    'html.svsz-lock,html.svsz-lock body{overflow:hidden}' +
    '.svsz-host .sarvati-addons__groups,.svsz-host .sarvati-addons__measurement,.svsz-host .sarvati-addons__header{display:none!important}' +
    '@media (prefers-reduced-motion:reduce){.svsz__c,.svsz__sw,.svsz__sw::after{transition:none}}';

  var host, form, btns, panel, note, err, modeRow, sizeStep, sizeRow, detailStep, pickBtn, pickImg, pickName, pickCode, embroideryEl = null;
  var priceEl, stickyPriceEl, basePrice = null, writingPrice = false, fallAuto = false;
  var selects = {};
  var rowOf = [];
  var state = { mode: VMODE ? 'Stitched' : 'Unstitched', size: null, design: null, designChosen: false, closure: '', padding: '', height: '', material: '', baseSize: '' };
  var MATERIALS = CFG.materials || ['Satin', 'Cotton', 'Cotton Lycra'];
  var matWrap = null;
  var VARIANTS = null;
  var baseStep = null, baseRow = null, heightStep = null;

  /* 30 Sep 2026 (Chirag): customers were picking the letter they wear in US
     brands and finding out on WhatsApp that our S is a 36 inch bust. The
     numbers behind a size are now printed the moment it is tapped, taken from
     the product's own size chart page when it has one, else the standard
     Sarvati chart. */
  var chartCache = null;
  function chartFor(size) {
    var want = String(size || '').toUpperCase().replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL');
    if (chartCache === null) {
      chartCache = {};
      try {
        if (CFG.sizeChartHtml && window.DOMParser) {
          var doc = new DOMParser().parseFromString(CFG.sizeChartHtml, 'text/html');
          var tables = [].slice.call(doc.querySelectorAll('table'));
          for (var t = 0; t < tables.length; t++) {
            var heads = [].map.call(tables[t].querySelectorAll('thead th, tr:first-child th, tr:first-child td'), function (h) { return h.textContent.trim().toUpperCase().replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL'); });
            var rows = [].slice.call(tables[t].querySelectorAll('tbody tr'));
            var got = false;
            rows.forEach(function (r) {
              var cells = [].map.call(r.querySelectorAll('td, th'), function (c) { return c.textContent.trim(); });
              var name = (cells[0] || '').toLowerCase();
              if (!/bust|chest|waist|hip/.test(name)) return;
              got = true;
              var key = /bust|chest/.test(name) ? 'Bust' : (/waist/.test(name) ? 'Waist' : 'Hip');
              for (var i = 1; i < cells.length && i < heads.length; i++) {
                if (!heads[i] || !/\d/.test(cells[i])) continue;
                chartCache[heads[i]] = chartCache[heads[i]] || {};
                chartCache[heads[i]][key] = cells[i];
              }
            });
            if (got) break;
          }
        }
      } catch (e) { chartCache = {}; }
    }
    if (chartCache[want]) return chartCache[want];
    var row = SIZES.filter(function (s) { return s[0] === want; })[0];
    return row ? { Bust: row[1], Waist: row[2], Hip: row[3] } : null;
  }
  var stdDefaultId = null, plusDefaultId = null;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function findButtons() {
    var all = [].slice.call(host.querySelectorAll('.sarvati-addons__button'));
    var out = { std: null, plus: null, ready: null, fall: null, shape: null, extra: [] };
    all.forEach(function (b) {
      var g = b.dataset.addonGroup || '';
      var t = b.dataset.addonTitle || '';
      if (g === 'blouse' || g === 'lehenga' || g === 'salwar') {
        if (/plus|measurement|custom/i.test(t) && !/^custom lehenga/i.test(t)) { if (!out.plus) out.plus = b; }
        else if (!out.std) out.std = b;
      } else if (g === 'ready') out.ready = b;
      else if (g === 'fall' || (/^additional/.test(g) && /fall/i.test(t))) { if (!out.fall) out.fall = b; }
      else if (g === 'shapewear' || (/^additional/.test(g) && /petticoat|shapewear/i.test(t))) { if (!out.shape) out.shape = b; }
      else if (/^additional/.test(g)) out.extra.push(b);
    });
    return out;
  }

  /* Set the theme's button state directly. Its script reads the class at
     submit time, so no click is needed and none is simulated. */
  function setBtn(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-selected', !!on);
  }
  function isOn(btn) { return !!btn && btn.classList.contains('is-selected'); }

  /* Money parsing that does not care which currency the shop is showing:
     whatever sits before the digits is the prefix (Rs. $ £ € ر.ق ...),
     whatever sits after is the suffix (" USD", " kr."), and the decimal
     separator is whichever of . or , comes last. Rewritten 21 September
     2026 so the price total works in every market, not only the six
     symbols the old pattern knew. */
  var MONEY = /^([^\d]*)(\d[\d.,\s]*\d|\d)([^\d]*)$/;
  function parseMoney(s) {
    var t = (s || '').replace(/\s+/g, ' ').trim();
    var m = t.match(MONEY);
    if (!m) return null;
    var raw = m[2].replace(/\s/g, '');
    var dec = raw.match(/[.,](\d{1,2})$/);
    var whole = dec ? raw.slice(0, raw.length - dec[0].length) : raw;
    var n = parseInt(whole.replace(/[.,]/g, ''), 10) + (dec ? parseInt(dec[1], 10) / Math.pow(10, dec[1].length) : 0);
    if (isNaN(n)) return null;
    var dsep = dec ? dec[0].charAt(0) : '.';
    return { sym: m[1], post: m[3], n: n, dsep: dsep, tsep: dsep === ',' ? '.' : ',' };
  }
  function fmtMoney(sym, n, like) {
    var dsep = like && like.dsep ? like.dsep : '.', tsep = like && like.tsep ? like.tsep : ',';
    var parts = n.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, tsep);
    return sym + parts.join(dsep) + (like && like.post ? like.post : '');
  }
  /* the price text of a theme add on button: its last span, so the label
     ("Custom", "Yes") is never mistaken for part of the currency */
  function priceOf(btn, sizeKey) {
    if (!btn) return '';
    if (sizeKey && VARIANTS && VARIANTS[sizeKey]) {
      return fmtMoney(basePrice ? basePrice.sym : '$', VARIANTS[sizeKey].cents / 100, basePrice);
    }
    var spans = btn.querySelectorAll('span');
    var txt = spans.length ? spans[spans.length - 1].textContent : btn.textContent;
    return (txt || '').replace(/\s+/g, ' ').trim();
  }
  function readBase() {
    if (!priceEl) return;
    var p = parseMoney(priceEl.textContent);
    if (p) basePrice = p;
  }

  function setProp(name, value) {
    if (!form) return;
    var input = form.querySelector('input[name="properties[' + name + ']"]');
    if (!value) { if (input && input.dataset.svsz) input.parentNode.removeChild(input); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.dataset.svsz = '1';
      form.appendChild(input);
    }
    input.value = value;
  }

  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, '').replace('measurements', 'measurement'); }
  function loadVariants() {
    if (!CFG.stitchHandle) return;
    fetch('/products/' + CFG.stitchHandle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p || !p.variants || p.variants.length < 2) return;
        var map = {};
        p.variants.forEach(function (v) {
          var key = norm(v.title);
          ['XS', 'S', 'M', 'L', 'XL', '2XL', 'Custom'].forEach(function (k) {
            var want = k === 'Custom' ? norm(CUSTOM) : norm(k);
            if (key === want || (k === 'Custom' && /measurement|custom/.test(key))) {
              if (!map[k]) map[k] = { id: v.id, cents: v.price };
            }
          });
        });
        if (Object.keys(map).length) { VARIANTS = map; sync(); }
      })
      .catch(function () {});
  }

  function sheet(title, fillCard) {
    var s = el('div', 'svsz-sheet');
    s.setAttribute('role', 'dialog');
    s.setAttribute('aria-modal', 'true');
    var card = el('div', 'svsz-sheet__card');
    var top = el('div', 'svsz-sheet__top');
    top.appendChild(el('h3', null, title));
    var x = el('button', 'svsz-sheet__x', '×');
    x.type = 'button';
    x.setAttribute('aria-label', 'Close');
    top.appendChild(x);
    card.appendChild(top);
    function close() {
      document.documentElement.classList.remove('svsz-lock');
      document.removeEventListener('keydown', esc);
      if (s.parentNode) s.parentNode.removeChild(s);
    }
    function esc(e) { if (e.key === 'Escape') close(); }
    fillCard(card, close);
    s.appendChild(card);
    x.addEventListener('click', close);
    s.addEventListener('click', function (e) { if (e.target === s) close(); });
    /* the design photographs are Sarvati's: no right click, drag or long press save */
    s.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    s.addEventListener('dragstart', function (e) { e.preventDefault(); });
    document.addEventListener('keydown', esc);
    document.documentElement.classList.add('svsz-lock');
    document.body.appendChild(s);
    x.focus();
  }

  function openGuide() {
    /* a suit carries its own size chart page (two different charts exist),
       so in variant mode the guide shows that page instead of the blouse table */
    if (CFG.sizeChartHtml) {
      sheet(T.guideTitle || 'Size chart', function (card) {
        var box = el('div', 'svsz-sheet__chart');
        box.innerHTML = CFG.sizeChartHtml;
        card.appendChild(box);
      });
      return;
    }
    sheet(GARMENT + ' size chart', function (card) {
      var table = document.createElement('table');
      table.innerHTML = '<thead><tr><th>Size</th><th>Bust</th><th>Waist</th>' + (LEHENGA ? '<th>Hip</th>' : '') + '</tr></thead>';
      var tb = document.createElement('tbody');
      SIZES.forEach(function (s) {
        var tr = document.createElement('tr');
        tr.innerHTML = '<td>' + s[0] + '</td><td>' + s[1] + '"</td><td>' + s[2] + '"</td>' + (LEHENGA ? '<td>' + s[3] + '"</td>' : '');
        tb.appendChild(tr);
      });
      table.appendChild(tb);
      card.appendChild(table);
      card.appendChild(el('p', null, T.guide || 'Body measurements in inches. Keep the tape comfortable, not tight. Need it made to your own measurements and style? Choose ' + CUSTOM + '.'));
    });
  }

  function paintDesign() {
    var d = state.design;
    if (!state.designChosen) {
      pickBtn.classList.add('is-empty');
      pickImg.hidden = true;
      pickName.textContent = PLEASE;
      pickCode.textContent = '';
      return;
    }
    pickBtn.classList.remove('is-empty');
    pickImg.hidden = false;
    pickImg.src = d ? d.image : (CFG.modelImage || '');
    pickImg.alt = '';
    pickName.textContent = d ? d.name : (T.sameAsModel || 'Same as the model');
    pickCode.textContent = d ? (d.code || '') : ('BD-01 · ' + (T.sameAsModelHint || 'Neckline and sleeves as photographed'));
  }

  function openDesigns() {
    sheet(GARMENT + ' design', function (card, close) {
      var grid = el('div', 'svsz-sheet__grid');
      function tile(d) {
        var b = el('button', 'svsz-d');
        b.type = 'button';
        if (state.designChosen && ((state.design && d && state.design.name === d.name) || (!state.design && !d))) b.classList.add('is-on');
        var img = document.createElement('img');
        img.src = d ? d.image : (CFG.modelImage || '');
        img.alt = d ? d.name : 'Same as the model';
        img.loading = 'eager';
        img.draggable = false;
        b.appendChild(img);
        var cap = el('span', null, d ? d.name : (T.sameAsModel || 'Same as the model'));
        if (d && d.code) { cap.appendChild(document.createTextNode(' ')); cap.appendChild(el('i', null, d.code)); }
        b.appendChild(cap);
        b.addEventListener('click', function () { state.design = d; state.designChosen = true; paintDesign(); sync(); close(); });
        return b;
      }
      grid.appendChild(tile(null));
      DESIGNS.forEach(function (d) { grid.appendChild(tile(d)); });
      card.appendChild(grid);
    });
  }

  function selectRow(caption, key, values) {
    var wrap = el('label', 'svsz__sel');
    wrap.appendChild(el('small', null, caption));
    var sel = document.createElement('select');
    var ph = document.createElement('option');
    ph.value = ''; ph.textContent = PLEASE;
    sel.appendChild(ph);
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v; o.textContent = v;
      sel.appendChild(o);
    });
    sel.classList.add('is-empty');
    sel.addEventListener('change', function () {
      state[key] = sel.value;
      sel.classList.toggle('is-empty', !sel.value);
      wrap.classList.remove('is-missing');
      sync();
    });
    wrap.appendChild(sel);
    selects[key] = wrap;
    return wrap;
  }

  function chip(label, value, onPick, pill, price) {
    var b = el('button', 'svsz__c' + (pill ? ' svsz__c--pill' : '') + (price ? ' svsz__c--priced' : ''), label);
    b.type = 'button';
    b.dataset.v = value;
    if (price) b.appendChild(el('b', null, '+' + price));
    b.setAttribute('aria-pressed', 'false');
    b.addEventListener('click', function () { onPick(value); });
    return b;
  }

  /* One add on row: the whole row toggles, the pill only shows the state.
     A 350ms guard swallows the second of two events a phone can send for
     one tap. */
  function addRow(label, btn, learn) {
    var row = el('div', 'svsz__add');
    row.setAttribute('role', 'switch');
    row.setAttribute('tabindex', '0');
    row.setAttribute('aria-checked', 'false');
    row.setAttribute('aria-label', label);
    var s = el('span', null, label);
    var p = priceOf(btn);
    if (p) s.appendChild(el('i', null, '+' + p));
    if (learn) {
      var a = el('a', null, T.learn || 'What is this?');
      a.setAttribute('role', 'button');
      a.setAttribute('tabindex', '0');
      a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); learn.click(); });
      a.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); learn.click(); } });
      s.appendChild(a);
    }
    var sw = el('span', 'svsz__sw');
    sw.setAttribute('aria-hidden', 'true');
    var last = 0;
    function flip() {
      var now = Date.now();
      if (now - last < 350) return;
      last = now;
      var on = !isOn(btn);
      setBtn(btn, on);
      if (btn === btns.fall) fallAuto = false;
      sync();
    }
    row.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a')) return; flip(); });
    row.addEventListener('keydown', function (e) { if (e.target !== row) return; if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); flip(); } });
    row.appendChild(s);
    row.appendChild(sw);
    rowOf.push([btn, row, sw]);
    return row;
  }
  function rowFor(btn) { for (var i = 0; i < rowOf.length; i++) if (rowOf[i][0] === btn) return rowOf[i]; return null; }
  function showRow(btn, visible) { var r = rowFor(btn); if (r) r[1].hidden = !visible; }
  function paintRows() {
    rowOf.forEach(function (r) {
      var on = isOn(r[0]);
      r[2].classList.toggle('is-on', on);
      r[1].setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function build() {
    panel = el('div', 'svsz');

    var lab1 = el('p', 'svsz__lab');
    lab1.appendChild(el('span', null, T.stitchLabel || ((GARMENT === 'Choli' ? 'Lehenga Choli' : GARMENT) + ' stitching option'))); /* label only; order properties keep the short 'Choli' name (27 Sep 2026) */
    if (!VMODE) panel.appendChild(lab1);
    modeRow = el('div', 'svsz__row');
    modeRow.appendChild(chip(T.unstitched || 'Unstitched', 'Unstitched', function (v) { state.mode = v; err.classList.remove('is-on'); sync(); }, true));
    modeRow.appendChild(chip(T.stitched || 'Stitched', 'Stitched', function (v) { state.mode = v; err.classList.remove('is-on'); sync(); }, true));
    if (!VMODE) panel.appendChild(modeRow);

    sizeStep = el('div', 'svsz__step');
    var lab2 = el('p', 'svsz__lab');
    var sizeSpan = el('span', null, T.sizeLabel || 'Size');
    if (!VMODE && priceOf(btns.std)) sizeSpan.appendChild(el('em', null, '· ' + (T.stitchingWord || 'stitching') + ' +' + priceOf(btns.std)));
    lab2.appendChild(sizeSpan);
    var g = el('button', null, T.guideLink || 'Size chart');
    g.type = 'button';
    g.addEventListener('click', openGuide);
    lab2.appendChild(g);
    sizeStep.appendChild(lab2);
    sizeRow = el('div', 'svsz__row');
    function pickSize(v) { state.size = v; err.classList.remove('is-on'); sync(); }
    if (VMODE) {
      VSIZES.forEach(function (x) {
        var c = chip(x.v, x.v, pickSize);
        if (x.available === false) { c.disabled = true; c.title = 'Sold out'; }
        sizeRow.appendChild(c);
      });
    } else {
      SIZES.forEach(function (s) { var c = chip(s[0], s[0], pickSize); c.classList.add('svsz__c--size'); sizeRow.appendChild(c); });
    }
    /* Custom stitching is its own full width row: name, a short hint, and the price of the product it adds */
    function customRow(label, value, btn, hint) {
      var c = chip('', value, pickSize);
      c.classList.add('svsz__c--custom');
      var left = el('span', null, label);
      if (hint) left.appendChild(el('small', null, hint));
      c.appendChild(left);
      var p = priceOf(btn);
      if (p) c.appendChild(el('b', null, '+' + p));
      return c;
    }
    var customBtn = VMODE ? btns.std : ((CFG.measurementsUse === 'std' || !btns.plus) ? btns.std : btns.plus);
    sizeRow.appendChild(customRow(CUSTOM, 'Custom', customBtn, T.customHint || 'to your measurements'));
    /* suits kept both stitching products: Custom is the standard one, Plus the plus size one */
    if (VMODE && btns.plus) sizeRow.appendChild(customRow(PLUS, 'Plus', btns.plus, T.plusHint || ''));
    sizeStep.appendChild(sizeRow);
    /* 30 Sep 2026: on a sized product, Custom or Plus stitching still needs a real
       garment to alter, exactly as the old orders read ("size L" + the stitching
       line). The customer picks the closest ready size here; it is required, it
       drives the variant, and it is written on the order as "Base size". */
    if (VMODE) {
      baseStep = el('div', 'svsz__step');
      var lab3 = el('p', 'svsz__lab');
      /* 1 Oct 2026 (Chirag: two identical rows confused customers): a question for
         the heading, the hint on its own line, and no Un-Stitch here, because an
         unstitched piece cannot be altered to measurements. */
      lab3.appendChild(el('span', null, T.baseLabel || 'Which ready size is closest to you?'));
      baseStep.appendChild(lab3);
      baseStep.appendChild(el('p', 'svsz__basehint', T.baseHint || 'We start from this size and alter it to your measurements.'));
      baseRow = el('div', 'svsz__row');
      VSIZES.forEach(function (x) {
        if (/^un.?stitch/i.test(String(x.v).trim())) return;
        var c = chip(x.v, x.v, function (v) { state.baseSize = v; baseRow.classList.remove('is-missing'); err.classList.remove('is-on'); sync(); });
        if (x.available === false) { c.disabled = true; c.title = 'Sold out'; }
        baseRow.appendChild(c);
      });
      baseStep.appendChild(baseRow);
      sizeStep.appendChild(baseStep);
    }
    note = el('p', 'svsz__note');
    sizeStep.appendChild(note);
    panel.appendChild(sizeStep);

    detailStep = el('div', 'svsz__step');
    var two = el('div', 'svsz__two');
    two.appendChild(selectRow(T.paddingLabel || 'Padding', 'padding', PADDINGS));
    two.appendChild(selectRow(T.closureLabel || 'Closure', 'closure', CLOSURES));
    two.hidden = true; /* kept for a future switch back; not shown */
    if (LEHENGA) {
      var one = el('div', 'svsz__one');
      one.appendChild(selectRow(T.heightLabel || 'Height', 'height', HEIGHTS));
      detailStep.appendChild(one);
    }
    var pw = el('div', 'svsz__pickwrap');
    pw.hidden = true; /* design picker kept for a future switch back; not shown */
    pw.appendChild(el('small', null, T.designLabel || (GARMENT + ' design')));
    pickBtn = el('button', 'svsz__pick' + (DESIGNS.length ? '' : ' svsz__pick--static'));
    pickBtn.type = 'button';
    pickImg = document.createElement('img');
    pickImg.draggable = false;
    pickImg.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    pickBtn.appendChild(pickImg);
    var txt = el('span');
    pickName = el('span');
    pickCode = el('i');
    txt.appendChild(pickName);
    txt.appendChild(pickCode);
    pickBtn.appendChild(txt);
    pickBtn.addEventListener('click', function () {
      pickBtn.classList.remove('is-missing');
      if (DESIGNS.length) openDesigns();
      else { state.design = null; state.designChosen = true; paintDesign(); sync(); }
    });
    pw.appendChild(pickBtn);
    detailStep.appendChild(pw);
    /* 28 Sep 2026: padding, closure and design are no longer asked; only a lehenga's height */
    if (LEHENGA && !SUIT && !VMODE) panel.appendChild(detailStep);
    /* 30 Sep 2026: a sized suit or lehenga asks for height too, the way the
       unstitched lehenga always has, so the length can be altered without a
       WhatsApp round trip. Required for a standard size. */
    if (VMODE) {
      heightStep = el('div', 'svsz__step');
      var hone = el('div', 'svsz__one');
      hone.appendChild(selectRow(T.heightLabel || 'Height', 'height', HEIGHTS));
      heightStep.appendChild(hone);
      heightStep.appendChild(el('p', 'svsz__hint', T.heightHint || 'So we can alter the length to fit you. Minor alterations are free.'));
      sizeStep.appendChild(heightStep);
    }
    paintDesign();
    if (T.embroideryNote && !SUIT && !VMODE) { embroideryEl = el('p', 'svsz__hint', GARMENT === 'Choli' ? T.embroideryNote.replace(/blouses/g, 'cholis').replace(/blouse/g, 'choli') : T.embroideryNote); embroideryEl.hidden = true; panel.appendChild(embroideryEl); }

    var adds = el('div', 'svsz__adds');
    var learn = host.querySelector('[data-sarvati-addons-guide-open]');
    if (btns.ready) adds.appendChild(addRow(T.ready || 'Pre-Drape this Saree', btns.ready, learn));
    if (btns.fall)  adds.appendChild(addRow(T.fall  || 'Fall and Edging', btns.fall));
    if (btns.shape) {
      adds.appendChild(addRow(T.shape || 'Petticoat/Shapewear', btns.shape));
      matWrap = el('div', 'svsz__mat');
      matWrap.hidden = true;
      matWrap.appendChild(selectRow(T.materialLabel || 'Petticoat material', 'material', MATERIALS));
      adds.appendChild(matWrap);
    }
    btns.extra.forEach(function (b) { adds.appendChild(addRow(b.dataset.addonTitle || 'Add on', b)); });
    if (adds.children.length) {
      var al = el('p', 'svsz__lab');
      al.appendChild(el('span', null, T.addLabel || ('Add to this ' + (SUIT ? 'suit' : (LEHENGA ? 'lehenga' : 'saree')))));
      al.style.marginTop = '16px';
      panel.appendChild(al);
      panel.appendChild(adds);
    }

    err = el('p', 'svsz__err');
    panel.appendChild(err);

    host.insertBefore(panel, host.querySelector('.sarvati-addons__groups'));
  }

  function waLink(label) {
    if (!WA) return '';
    return ' <a href="https://api.whatsapp.com/send?phone=' + WA + '" target="_blank" rel="noopener">' + (label || 'WhatsApp us') + '</a>';
  }

  /* variant mode: the theme's own size radio is ticked for the chosen chip,
     so the theme changes the variant, price and availability as usual */
  function sizeWrap() {
    /* Impulse keeps the variant picker OUTSIDE the form and copies the
       choice into the form's select[name=id] itself, so look in the whole
       product section, not the form */
    var sec = (host && host.closest('[data-section-type="product"], .product-section, [id^="ProductSection"]')) || document;
    return sec.querySelector('.variant-input-wrap[data-handle="size"]') || sec.querySelector('.variant-input-wrap');
  }
  /* 1 Oct 2026: the theme writes the new variant's price into priceEl at
     once, inside dispatchEvent. paintPrice() in sync() then wrote the price
     read at page load over it, and the observer in start() skipped the
     theme's write because writingPrice was still set. A 3XL at $164 showed
     $124 while the cart got the $164 variant. So when the theme replaced the
     price during the change, take it as the new base here. Node identity,
     not text: a painted total can equal the new price by chance. */
  function pickVariant(v) {
    var before = priceEl ? priceEl.firstChild : null;
    pickThemeVariant(v);
    if (priceEl && priceEl.firstChild !== before) readBase();
  }
  function pickThemeVariant(v) {
    var w = sizeWrap();
    if (w) {
      var r = [].slice.call(w.querySelectorAll('input[type="radio"]')).filter(function (i) { return i.value === v; })[0];
      if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    var sec = (host && host.closest('[data-section-type="product"], .product-section, [id^="ProductSection"]')) || document;
    var sel = sec.querySelector('select[data-index]');
    if (sel && sel.value !== v) { sel.value = v; sel.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function hideVariantPicker() {
    var w = sizeWrap();
    var wrap = w && w.closest('.variant-wrapper');
    if (wrap) wrap.style.display = 'none';
  }

  function paintPrice(stitchBtn, stitchKey) {
    if (!priceEl || !basePrice) return;
    var sum = basePrice.n;
    [stitchBtn].concat([btns.ready, btns.fall, btns.shape], btns.extra).forEach(function (b) {
      if (!isOn(b)) return;
      var p = parseMoney(priceOf(b, b === stitchBtn ? stitchKey : null));
      if (p && p.sym === basePrice.sym && p.post === basePrice.post) sum += p.n;
    });
    var txt = fmtMoney(basePrice.sym, sum, basePrice);
    writingPrice = true;
    if (priceEl.textContent.trim() !== txt) priceEl.textContent = txt;
    if (stickyPriceEl && stickyPriceEl.textContent.trim() !== txt) stickyPriceEl.textContent = txt;
    setTimeout(function () { writingPrice = false; }, 0);
  }

  function sync() {
    var stitchedMode = VMODE || state.mode === 'Stitched';
    var v = stitchedMode ? state.size : null;
    var plus = v === 'Plus';
    var custom = v === 'Custom' || plus;
    var standard = !!v && !custom;
    var stitched = standard || custom;
    /* 1 Oct 2026: on sized suits Un-Stitch is a real size chip but means NO stitching:
       no Height, and the order must say Unstitched (it said Stitched and demanded a height) */
    var unst = VMODE && !!v && /^un.?stitch/i.test(String(v).trim());

    [].forEach.call(modeRow.children, function (c) { var on = c.dataset.v === state.mode; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    [].forEach.call(sizeRow.children, function (c) { var on = c.dataset.v === v; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    sizeStep.classList.toggle('is-on', stitchedMode);
    detailStep.classList.toggle('is-on', standard && LEHENGA && !SUIT && !VMODE);
    if (embroideryEl) embroideryEl.hidden = !stitched;
    if (matWrap) {
      var shapeOn = isOn(btns.shape);
      matWrap.hidden = !shapeOn;
      if (!shapeOn && selects.material) { var ms = selects.material.querySelector('select'); state.material = ''; ms.value = ''; ms.classList.add('is-empty'); selects.material.classList.remove('is-missing'); }
    }
    if (VMODE && standard) pickVariant(v);
    /* 1 Oct 2026: with Custom or Plus chosen, fade the top size chips so the eye goes to the closest ready size row */
    sizeRow.classList.toggle('svsz__row--faded', VMODE && custom);
    /* 30 Sep 2026: with Custom or Plus chosen on a sized product the form used to
       keep whatever size the theme had preselected (usually the first, XS). The
       "Closest ready size" row below now decides the variant and is required. */
    var baseSize = '';
    if (heightStep) heightStep.classList.toggle('is-on', VMODE && standard && !unst);
    if (baseStep) {
      baseStep.classList.toggle('is-on', VMODE && custom);
      if (VMODE && custom) {
        baseSize = state.baseSize;
        [].forEach.call(baseRow.children, function (c) { var on = c.dataset.v === baseSize; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        if (baseSize) pickVariant(baseSize);
      } else state.baseSize = '';
    }

    var stitchBtn = null, stitchKey = null;
    if (stitched && !(VMODE && standard)) {
      if (VARIANTS && VARIANTS[v] && btns.std) { stitchBtn = btns.std; stitchKey = v; }
      else if (standard) stitchBtn = btns.std;
      else if (plus) stitchBtn = btns.plus || btns.std;
      else stitchBtn = (CFG.measurementsUse === 'std' || !btns.plus) ? btns.std : btns.plus;
    }
    if (btns.std) btns.std.dataset.addonVariantId = (stitchBtn === btns.std && stitchKey) ? VARIANTS[stitchKey].id : stdDefaultId;
    if (btns.plus) btns.plus.dataset.addonVariantId = plusDefaultId;
    setBtn(btns.std, stitchBtn === btns.std);
    setBtn(btns.plus, !!btns.plus && stitchBtn === btns.plus);

    /* 28 Sep 2026: fall is a plain add on again, never included in a size */
    var fallIncluded = false;
    if (btns.fall) {
      if (fallIncluded) {
        showRow(btns.fall, false);
        if (FALL_MODE === 'price') { setBtn(btns.fall, false); fallAuto = false; }
        else { setBtn(btns.fall, true); fallAuto = true; }
      } else {
        showRow(btns.fall, true);
        if (fallAuto) { setBtn(btns.fall, false); fallAuto = false; }
      }
    }
    showRow(btns.shape, true);
    showRow(btns.ready, true);
    var waiting = stitchedMode && !v;
    [btns.fall, btns.shape, btns.ready].concat(btns.extra).forEach(function (b) { if (b && waiting) showRow(b, false); });
    paintRows();

    if (unst) {
      note.innerHTML = (T.noteUnstitched || 'Unstitched: you receive the fabric as it is, not stitched.');
    } else if (standard) {
      var row = SIZES.filter(function (s) { return s[0] === v; })[0];
      if (VMODE) {
        var m = chartFor(v);
        note.innerHTML = 'Size <b>' + v + '</b>' + (m ? (m.Bust ? '<i>·</i>Bust ' + m.Bust + '"' : '') + (m.Waist ? '<i>·</i>Waist ' + m.Waist + '"' : '') + (m.Hip ? '<i>·</i>Hip ' + m.Hip + '"' : '') : '') +
          (m ? ' <small>' + (T.sizeTail || 'Body measurements in inches. Not sure? Check the size chart above.') + '</small>' : '');
      } else
      note.innerHTML = 'Stitched in size <b>' + v + '</b>' + ((row && !VMODE) ? '<i>·</i>Bust ' + row[1] + '"<i>·</i>Waist ' + row[2] + '"' + (LEHENGA ? '<i>·</i>Hip ' + row[3] + '"' : '') : '') +
        ''; /* 28 Sep 2026: no "above 2XL" line */
    } else if (custom) {
      /* 28 Sep 2026: the measurement page on sarvati.com wins over the old Google Form link */
      var formUrl = CFG.measurementsPage
        ? CFG.measurementsPage + '?garment=' + (SUIT ? 'suit' : (LEHENGA ? 'lehenga' : 'blouse')) + '&item=' + encodeURIComponent(document.title.split(/\s[–|-]\s/)[0].slice(0, 80))
        : ((stitchBtn && stitchBtn.dataset.addonMeasurementUrl) || '');
      note.innerHTML = (T.noteCustom || 'Stitched to your own measurements.') +
        (formUrl ? ' <a href="' + formUrl.replace(/"/g, '&quot;') + '" target="_blank" rel="noopener">' + (T.formLink || 'Fill the measurement form') + '</a>' : '') +
        (T.noteCustomTail ? '<small>' + T.noteCustomTail + '</small>' : '') +
        (WA ? '<span class="svsz__stylist">' + (T.stylistText || 'Not sure about your measurements?') +
          ' <a href="https://api.whatsapp.com/send?phone=' + WA + '&text=' + encodeURIComponent(T.stylistMessage || 'Hi Sarvati, I would like some help with my measurements for custom stitching.') + '" target="_blank" rel="noopener">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.5l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 12 12 0 0 0 4.6 4 5.3 5.3 0 0 0 3.2.7 2.7 2.7 0 0 0 1.8-1.3 2.2 2.2 0 0 0 .2-1.3c-.1-.1-.3-.2-.5-.3z"/></svg>' +
          (T.stylistButton || 'Ask a Sarvati Stylist') + '</a></span>' : '');
    } else {
      note.innerHTML = '';
    }

    setProp(GARMENT + ' stitching', (stitchedMode && !unst) ? 'Stitched' : 'Unstitched');
    setProp(GARMENT + ' size', (stitched && !unst) ? (plus ? PLUS : (custom ? CUSTOM : v)) : '');
    setProp('Base size', VMODE && custom && baseSize ? baseSize + ' (altered to your measurements)' : '');
    var d = state.design;
    setProp(GARMENT + ' design', standard && state.designChosen ? (d ? (d.name + (d.code ? ' (' + d.code + ')' : '')) : (T.sameAsModel || 'Same as the model') + ' (BD-01)') : '');
    setProp(GARMENT + ' closure', standard ? state.closure : '');
    setProp(GARMENT + ' padding', standard ? state.padding : '');
    setProp('Height', standard && !unst && (VMODE || LEHENGA) ? state.height : '');
    setProp('Fall & edging', '');
    setProp('Petticoat material', btns.shape && isOn(btns.shape) ? state.material : '');

    paintPrice(stitchBtn, stitchKey);
    if (!missing().length) err.classList.remove('is-on');

    if (window.SarvatiDelivery) {
      var dl = document.querySelector('[data-sarvati-delivery]');
      window.SarvatiDelivery.setExtra(custom ? (+(dl && dl.dataset.extra) || 2) : 0);
    }
  }

  function missing() {
    var list = [];
    if (btns.shape && isOn(btns.shape) && !state.material && selects.material) list.push({ what: (T.materialLabel || 'petticoat material').toLowerCase(), el: selects.material });
    if (!VMODE && state.mode !== 'Stitched') return list;
    if (!state.size) { list.push({ what: T.needSize || 'a size', el: sizeRow }); return list; }
    if (VMODE && (state.size === 'Custom' || state.size === 'Plus') && !state.baseSize) { list.push({ what: T.needBase || 'your closest ready size', el: baseRow }); return list; }
    if (VMODE && state.size !== 'Custom' && state.size !== 'Plus' && !/^un.?stitch/i.test(String(state.size).trim()) && !state.height) { list.push({ what: (T.heightLabel || 'height').toLowerCase(), el: selects.height }); return list; }
    if (state.size === 'Custom' || state.size === 'Plus' || SUIT || VMODE) return list;
    if (LEHENGA && !state.height) list.push({ what: (T.heightLabel || 'height').toLowerCase(), el: selects.height });
    return list;
  }
  function guard(e) {
    var m = missing();
    if (!m.length) { err.classList.remove('is-on'); return true; }
    e.preventDefault();
    e.stopImmediatePropagation();
    m.forEach(function (x) { if (x.el && x.el.classList) x.el.classList.add('is-missing'); });
    var names = m.map(function (x) { return x.what; });
    err.textContent = (T.needText || 'Please choose ') + (names.length > 1 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names[0]) + (T.needTail || ' before adding to cart.');
    err.classList.add('is-on');
    (m[0].el || err).scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }

  function start() {
    host = document.querySelector('[data-sarvati-addons]');
    if (!host) return;
    form = document.querySelector('form.product-single__form') ||
           document.querySelector('form[action*="/cart/add"]');

    btns = findButtons();
    if (!btns.std && !btns.plus) return;
    stdDefaultId = btns.std ? btns.std.dataset.addonVariantId : null;
    plusDefaultId = btns.plus ? btns.plus.dataset.addonVariantId : null;

    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    priceEl = document.querySelector('[data-product-price]');
    stickyPriceEl = document.querySelector('[data-sarvati-sticky-atc-price]');
    readBase();

    host.classList.add('svsz-host');
    if (VMODE) hideVariantPicker();
    build();
    sync();
    loadVariants();

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-add-to-cart]');
      if (!b || (form && !form.contains(b))) return;
      guard(e);
    }, true);
    if (form) form.addEventListener('submit', function (e) { guard(e); }, true);

    if (priceEl && window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        if (writingPrice) return;
        clearTimeout(t);
        t = setTimeout(function () { readBase(); sync(); }, 60);
      }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();